// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container.job[data-v-1a4023d4]  .el-form-item__error {\n  top: 40px;\n}", ""]);
// Exports
module.exports = exports;
